export default __webpack_public_path__ + "static/media/bitrix24.856e24bb.png";